import React from 'react'
import { Tooltip } from 'antd'

const PermissionsTooltip: React.FC<{ hasPermission: boolean }> = ({ children, hasPermission }) => {
  return <Tooltip title={!hasPermission && 'Unauthorized'}>{children}</Tooltip>
}

export default PermissionsTooltip
